<template>
  <b-overlay :show="show" rounded="md" :shown="shown()">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>

      <b-row align-h="center" style="width: 100%; margin-top: 60px">
        <b-col cols="12" style="padding-top: 5px" class="pl-0 pr-0 cart-nav">
          <b-row style="width: 100%">
            <b-col lg="6" class="pl-pr-0-sm hide-when-big">
              <b-row
                class="pl-3 pt-0 reduced_pl_pr"
                style="font-size: 28px; padding-bottom: 1px"
              >
                <b
                  style="font-size: 33px; padding-bottom: 1px"
                  class="h1-font"
                  data-aos="fade-left"
                  data-aos-delay="250"
                  >New Classic Tracker
                </b>
              </b-row>
              <ReviewPanel ref="t1reviewpanel_a"></ReviewPanel>
              <b-row class="mt-3">
                <b-col style="max-width: 500px" class="pl-pr-0-sm">
                  Our most advanced, oral care tracking technology at an
                  affordable price! Built-in battery lasts up to 12 months.
                  Works with any toothbrush; manual or electric; any brand.
                  Pairs with app to set goals, get feedback, earn rewards and
                  share with your dentist.
                </b-col>
              </b-row>
            </b-col>

            <b-col
              lg="6"
              style="
                border-radius: 25px;
                border: 0px solid;
                padding-left: 0;
                padding-right: 0;
              "
            >
              <b-row>
                <b-col class="pt-5 pb-5 reduced-pt-small">
                  <b-img
                    :src="selectedimage()"
                    fluid
                    rounded
                    center
                    style="max-width: 100%; max-height: 512px"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row class="pt-4 pl-3 pr-3">
                <b-col
                  v-for="(item, index) in imagelist"
                  :key="index"
                  @mouseover="hoversample(index)"
                  class="pl-1 pr-1"
                  align-self="center"
                  style="max-width: 120px"
                >
                  <b-img
                    :src="item"
                    fluid
                    rounded
                    :class="{ 'underline-blue': hoverindex == index }"
                    center
                    style=""
                  ></b-img>
                </b-col>
              </b-row>
              <b-row class="pt-5" style="justify-content: center">
                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/worldwide.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    Worldwide Shipping
                  </b-row>
                </b-col>

                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/fastdelivery.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    Fast Delivery
                  </b-row>
                </b-col>
                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/7dayreturn.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    30 Day Guarantee
                  </b-row>
                </b-col>
                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/warranty.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    Factory Warranty
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pt-1">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>
              <b-row class="pl-3 reduced_pl_pr hide-when-small">
                Have questions? We can help.
                <a href="/#/contact" style="padding-left: 6px"> Contact us</a>
              </b-row>
            </b-col>

            <b-col lg="6" class="pl-pr-0-sm">
              <b-row
                class="pl-3 pt-5 reduced_pl_pr hide-when-small"
                style="font-size: 28px; padding-bottom: 1px"
              >
                <b
                  style="font-size: 33px; padding-bottom: 1px"
                  class="h1-font"
                  data-aos="fade-left"
                  data-aos-delay="250"
                  >New Classic Tracker</b
                >
              </b-row>
              <b-row class="hide-when-small">
                <b-col>
                  <ReviewPanel ref="t1reviewpanel_b"></ReviewPanel>
                </b-col>
              </b-row>

              <b-row class="mt-3 hide-when-small">
                <b-col style="max-width: 500px" class="pl-pr-0-sm">
                  Our most advanced, oral care tracking technology at an
                  affordable price! Built-in battery lasts up to 12 months.
                  Works with any toothbrush; manual or electric; any brand.
                  Pairs with app to set goals, get feedback, earn rewards and
                  share with your dentist.
                </b-col>
              </b-row>

              <b-row class="pt-1 hide-when-small">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row
                class="pl-3 pt-2 h3-font reduced_pl_pr"
                style="font-size: 22px; padding-bottom: 1px; font-weight: 700"
                data-aos="fade-left"
                data-aos-delay="350"
              >
                Please select your bundle
              </b-row>
              <b-row
                class="pl-3 pt-0 reduced_pl_pr"
                style="font-size: 22px; padding-bottom: 10px"
                data-aos="fade-left"
                data-aos-delay="450"
              >
                <a href="#/select_t4">Looking for more bundle offers？</a>
              </b-row>

              <b-row
                class="pl-3 reduced_pl_pr"
                v-if="
                  getCoupon() == 'babysideburns' || getCoupon() == 'A3KzVdj8'
                "
              >
                <b-col class="banner" style="max-width: 500px">
                  <a href="/#/select" style="color: white; align-self: center"
                    >Baby Sideburns Special Price!</a
                  >
                </b-col>
              </b-row>

              <b-row
                class="pl-3 reduced_pl_pr"
                v-if="
                  getCoupon() == 'peachjar0427'
                "
              >
                <b-col class="banner" style="max-width: 500px">
                  <a href="/#/select" style="color: white; align-self: center"
                    >Extra 20% off for LexRich5!</a
                  >
                </b-col>
              </b-row>

              <b-row
                class="pl-3 reduced_pl_pr"
                v-if="
                  getCoupon() == 'dV7sL3vU'
                "
              >
                <b-col class="banner" style="max-width: 500px">
                  <a href="/#/select" style="color: white; align-self: center"
                    >Flash Sale, Extra 10% Off</a
                  >
                </b-col>
              </b-row>

              <b-row
                class="pl-3 reduced_pl_pr"
                v-else-if="getCoupon() == '5minutesformom'"
              >
                <b-col class="banner" style="max-width: 500px">
                  <a href="/#/select" style="color: white; align-self: center"
                    >5 Minutes for Mom Special Price!</a
                  >
                </b-col>
              </b-row>

              <b-row
                class="pl-3 reduced_pl_pr"
                v-else-if="getCoupon() == 'Sixfr2n3'"
              >
                <b-col class="banner" style="max-width: 500px">
                  <a href="/#/select" style="color: white; align-self: center"
                    >Black Friday Sale - Extra 15% Off</a
                  >
                </b-col>
              </b-row>

              <b-row
                class="pl-3 reduced_pl_pr"
                v-else-if="getCoupon() == 'mylifesuckers'"
              >
                <b-col class="banner" style="max-width: 500px">
                  <a href="/#/select" style="color: white; align-self: center"
                    >MyLifeSuckers - Extra 10% Off</a
                  >
                </b-col>
              </b-row>

              <b-row
                class="pl-3 reduced_pl_pr"
                v-else-if="getCoupon() == 'TDm1cVpj'"
              >
                <b-col class="banner" style="max-width: 500px">
                  <a href="/#/select" style="color: white; align-self: center"
                    >Holiday Sales! - Extra 10% Off</a
                  >
                </b-col>
              </b-row>

              <b-row class="pl-3 reduced_pl_pr" v-else hidden>
                <b-col class="banner" style="max-width: 500px">
                  <a href="/#/select" style="color: white; align-self: center"
                    >Memorial Day Sale! Ends on May 31.</a
                  >
                </b-col>
              </b-row>

              <b-row class="pl-3 pt-3 reduced_pl_pr">
                <b-col
                  :class="getSelectProductClass(0)"
                  style="max-width: 500px; cursor: pointer"
                  @click="clicksku(0)"
                >
                  <b-row class="pt-2 pb-2">
                    <b-col cols="8" class="reduced_pl_pr">
                      <b-row>
                        <b style="font-size: 24px" class="h3-font"
                          >1 Tracker Bundle</b
                        >
                      </b-row>
                      <b-row class="pt-2">
                        For 1 user, includes 1 Tracker and 1 Hub. Ready to use.
                      </b-row>
                    </b-col>
                    <b-col cols="4" class="reduced_pl_pr">
                      <b-row align-v="end" style="justify-content: flex-end">
                        <b style="font-size: 24px" class="h3-font"
                          >$ {{ getBundlePrice(true, true, 0) }}</b
                        >
                      </b-row>
                      <b-row
                        class="pt-2"
                        style="justify-content: flex-end"
                        v-if="
                          getBundlePrice(true, false, 0) -
                            getBundlePrice(true, true, 0) ==
                          0
                        "
                      >
                        Starter Pack
                      </b-row>
                      <b-row
                        class="pt-0"
                        style="justify-content: flex-end"
                        v-if="
                          getBundlePrice(true, false, 0) -
                            getBundlePrice(true, true, 0) ==
                          0
                        "
                      >
                      </b-row>
                      <b-row
                        class="pt-2"
                        style="justify-content: flex-end"
                        v-if="
                          getBundlePrice(true, false, 0) -
                            getBundlePrice(true, true, 0) >
                          0
                        "
                      >
                        <s> was $ {{ getBundlePrice(true, false, 0) }}</s>
                      </b-row>
                      <b-row
                        class="pt-0"
                        style="justify-content: flex-end; color: #12b8ed"
                        v-if="
                          getBundlePrice(true, false, 0) -
                            getBundlePrice(true, true, 0) >
                          0
                        "
                      >
                        <b
                          >save $
                          {{
                            (
                              getBundlePrice(true, false, 0) -
                              getBundlePrice(true, true, 0)
                            ).toFixed(2)
                          }}</b
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pl-3 pt-3 reduced_pl_pr" hidden>
                <b-col
                  :class="getSelectProductClass(1)"
                  style="max-width: 500px; cursor: pointer"
                  @click="clicksku(1)"
                >
                  <b-row class="pt-2 pb-2">
                    <b-col cols="8" class="reduced_pl_pr">
                      <b-row>
                        <b style="font-size: 24px" class="h3-font"
                          >2 Tracker Bundle</b
                        >
                      </b-row>
                      <b-row class="pt-2">
                        For 2 users, includes 2 Trackers and 1 Hub. Ready to
                        use.
                      </b-row>
                    </b-col>
                    <b-col
                      cols="4"
                      class="reduced_pl_pr"
                      v-if="
                        getBundlePrice(false, false, 1) -
                          getBundlePrice(true, true, 1) >
                        0
                      "
                    >
                      <b-row align-v="end" style="justify-content: flex-end">
                        <b style="font-size: 24px" class="h3-font"
                          >$ {{ getBundlePrice(true, true, 1) }}</b
                        >
                      </b-row>
                      <b-row class="pt-2" style="justify-content: flex-end">
                        <s>was $ {{ getBundlePrice(false, false, 1) }}</s>
                      </b-row>
                      <b-row
                        class="pt-0"
                        style="justify-content: flex-end; color: #12b8ed"
                      >
                        <b
                          >save $
                          {{
                            (
                              getBundlePrice(false, false, 1) -
                              getBundlePrice(true, true, 1)
                            ).toFixed(2)
                          }}</b
                        >
                      </b-row>
                    </b-col>
                    <b-col cols="4" class="reduced_pl_pr" v-else>
                      <b-row align-v="end" style="justify-content: flex-end">
                        <b style="font-size: 24px" class="h3-font"
                          >$ {{ getBundlePrice(true, true, 1) }}</b
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pl-3 pt-3 reduced_pl_pr">
                <b-col
                  :class="getSelectProductClass(2)"
                  style="max-width: 500px; cursor: pointer"
                  @click="clicksku(2)"
                >
                  <b-row class="pt-2 pb-2">
                    <b-col cols="8" class="reduced_pl_pr">
                      <b-row>
                        <b style="font-size: 24px" class="h3-font"
                          >Extra Tracker</b
                        >
                      </b-row>
                      <b-row class="pt-2">
                        Includes just 1 tracker. Requires an existing Hub to
                        work.
                      </b-row>
                    </b-col>
                    <b-col cols="4" class="reduced_pl_pr">
                      <b-row align-v="end" style="justify-content: flex-end">
                        <b style="font-size: 24px" class="h3-font"
                          >$ {{ getBundlePrice(true, true, 2) }}</b
                        >
                      </b-row>
                      <b-row
                        class="pt-2"
                        style="justify-content: flex-end"
                        v-if="
                          getBundlePrice(false, false, 2) -
                            getBundlePrice(true, true, 2) <
                          0.1
                        "
                      >
                      </b-row>
                      <b-row
                        class="pt-0"
                        style="justify-content: flex-end"
                        v-if="
                          getBundlePrice(false, false, 2) -
                            getBundlePrice(true, true, 2) <
                          0.1
                        "
                      >
                      </b-row>
                      <b-row
                        class="pt-2"
                        style="justify-content: flex-end"
                        v-if="
                          getBundlePrice(false, false, 2) -
                            getBundlePrice(true, true, 2) >=
                          0.1
                        "
                      >
                        <s>was $ {{ getBundlePrice(false, false, 2) }}</s>
                      </b-row>
                      <b-row
                        class="pt-0"
                        style="justify-content: flex-end; color: #12b8ed"
                        v-if="
                          getBundlePrice(false, false, 2) -
                            getBundlePrice(true, true, 2) >=
                          0.1
                        "
                      >
                        <b
                          >save $
                          {{
                            (
                              getBundlePrice(false, false, 2) -
                              getBundlePrice(true, true, 2)
                            ).toFixed(2)
                          }}</b
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pt-3" v-if="selectedproduct != 3">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>
              <b-row
                class="pl-3 pt-3 h3-font reduced_pl_pr"
                style="font-size: 22px; padding-bottom: 1px; font-weight: 700"
                v-if="selectedproduct != 3"
                ref="styleselect"
              >
                Select your tracker style
              </b-row>
              <b-row
                class="pl-3 pt-3 reduced_pl_pr"
                style="max-width: 510px"
                v-if="selectedproduct <= 2"
              >
                <b-col cols='3'
                  :class="getSelectStyleClass(0)"
                  style="
                    max-width: 500px;
                    cursor: pointer;
                    width: 45%;
                    margin-right: 1% !important;
                    position: relative;
                  "
                  @click="clickstyle(0)"
                >
                  <b-row class="pt-2 pb-2">
                    <b-col cols="12" class="reduced_pl_pr">
                      <b-row class="pt-2 pb-2">
                        <b-col>
                          <b-img
                            :src="options[0].url"
                            style="width: 60px; height: 60px"
                            center
                          >
                          </b-img>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols='3'
                  :class="getSelectStyleClass(1)"
                  style="
                    max-width: 500px;
                    cursor: pointer;
                    width: 45%;
                    margin-left: 1% !important;
                  "
                  @click="clickstyle(1)"
                >
                  <b-row class="pt-2 pb-2">
                    <b-col cols="12" class="reduced_pl_pr">
                      <b-row class="pt-2 pb-2">
                        <b-col>
                          <b-img
                            :src="options[1].url"
                            style="width: 60px; height: 60px"
                            center
                          >
                          </b-img>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row
                class="pl-3 pt-3 reduced_pl_pr"
                v-if="selectedproduct == 1"
                hidden
              >
                <dropdown-menu v-model="selectedstyle2open" style="width: 100%">
                  <button
                    class="product-select-box"
                    style="
                      max-width: 500px;
                      cursor: pointer;
                      font-size: 24px;
                      padding-left: 15px;
                      width: 100%;
                      text-align: left;
                    "
                  >
                    <b-row class="pb-2 pt-2">
                      <b-col cols="2" align-self="center" class="pl-0 pr-0">
                        <b-img
                          :src="options[selectedstyle2].url"
                          style="width: 50px; height: 50px"
                          center
                        >
                        </b-img>
                      </b-col>
                      <b-col cols="10" align-self="center" class="pr-0">
                        <b-row>
                          <b-col
                            cols="12"
                            style="font-size: 24px"
                            class="h3-font pl-0 pr-0"
                          >
                            Truthbrush
                            {{ options[selectedstyle2].text }}
                          </b-col>
                        </b-row>
                        <b-row class="pt-1"> Quantity: 1 </b-row>
                      </b-col>
                    </b-row>
                  </button>
                  <div slot="dropdown">
                    <a
                      class="dropdown-item"
                      v-for="(item, index) in options"
                      @click="clickstyle2(index)"
                      v-bind:key="item.text"
                    >
                      <b-row class="pb-2 pt-2">
                        <b-col cols="2" align-self="center" class="pl-0 pr-0">
                          <b-img
                            :src="options[index].url"
                            style="width: 40px; height: 40px"
                            center
                          >
                          </b-img>
                        </b-col>
                        <b-col cols="10" align-self="center">
                          <b-row class="pl-5">
                            <div style="font-size: 20px !important">
                              {{ options[index].text }}
                            </div>
                          </b-row>
                        </b-col>
                      </b-row>
                    </a>
                  </div>
                </dropdown-menu>
              </b-row>

              <b-row class="pt-3">
                <b-col
                  cols="12"
                  class="reduced_pl_pr"
                  v-if="selectedproduct < 2"
                >
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row
                class="pl-3 pt-2 h3-font reduced_pl_pr"
                style="font-size: 22px; padding-bottom: 1px; font-weight: 700"
                data-aos="fade-left"
                data-aos-delay="350"
                v-if="selectedproduct < 2"
              >
                Please configure your Hub
              </b-row>
              <b-row
                class="pl-3 pt-0 reduced_pl_pr pt-1"
                style="padding-bottom: 10px"
                data-aos="fade-left"
                data-aos-delay="450"
                v-if="selectedproduct < 2"
              >
                <b-col
                  class="pl-0 pr-0"
                  style="max-width: 500px"
                  v-if="adaptor == 0"
                >
                  Truthbrush Hub with USB plug. Automatically connects with multiple trackers. Adaptor not included.
                </b-col>
                <b-col
                  class="pl-0 pr-0"
                  style="max-width: 500px"
                  v-if="adaptor == 1"
                >
                  Add a Type A compatible USB power adapter to conveniently plug into a wall outlet (For US, Canada, Mexico, Others)

                </b-col>
                <b-col
                  class="pl-0 pr-0"
                  style="max-width: 500px"
                  v-if="adaptor == 2"
                >
                  Add a Type I compatible USB power adapter to conveniently plug into a wall outlet (For Australia, Others)

                </b-col>
              </b-row>

              <b-row
                class="pl-3 pt-3 reduced_pl_pr"
                style="max-width: 510px"
                v-if="selectedproduct < 2"
              >
                <b-col class='pl-0 pr-0'>
                  <b-row>
                    <b-col cols='3'
                      style="
                        max-width: 500px;
                        cursor: pointer;
                        width: 45%;
                        margin-right: 1% !important;
                        position: relative;
                        padding: 0 !important;
                      "
                      @click="clicksku_hub(0)"
                    >
                      <b-row class="pt-2 pb-2" :class="getSelectHubClass(0)">
                        <b-col cols="12" class="reduced_pl_pr pl-0 pr-0">
                          
                          <b-row class="pt-2">
                            <b-col class="pl-0 pr-0">
                              <b-img
                                src="img/products/travel_hub.png"
                                fluid
                              ></b-img>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols='3'
                      style="
                        max-width: 500px;
                        cursor: pointer;
                        width: 45%;
                        margin-right: 1% !important;
                        margin-left: 1% !important;
                        position: relative;
                        padding: 0 !important;
                      "
                      @click="clicksku_hub(1)"
                    >
                      <b-row class="pt-2 pb-2" :class="getSelectHubClass(1)">
                        <b-col cols="12" class="reduced_pl_pr pl-0 pr-0">
                          
                          <b-row class="pt-2">
                            <b-col class="pl-0 pr-0">
                              <b-img
                                src="img/products/hub_adaptor_type_1.png"
                                fluid
                              ></b-img>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols='3'
                      style="
                        max-width: 500px;
                        cursor: pointer;
                        margin-left: 1% !important;
                        width: 45%;
                        padding: 0 !important;
                      "
                      @click="clicksku_hub(2)"
                    >
                      <b-row class="pt-2 pb-2" :class="getSelectHubClass(2)">
                        <b-col cols="12" class="reduced_pl_pr pl-0 pr-0">
                          
                          <b-row class="pt-2">
                            <b-img
                              src="img/products/hub_adaptor_type_i.png"
                              fluid
                            ></b-img>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>
              <b-row class="pt-4 pb-2 pl-3 reduced_pl_pr">
                <b style="font-size: 24px" class="h3-font">{{
                  getproductInfo()
                }}</b>
              </b-row>
              <b-row class="pt-3 pb-3 pl-3 reduced_pl_pr" style='cursor:pointer' @click="gotoSubscription()" hidden>
                            <b-col
                              style="background-color: #e7f8fd; max-width: 496px"
                              class="pt-3 pb-3 pr-0"
                            >
                              <b-row>
                                <b-col
                                  cols="2"
                                  class="reduced_pl_pr"
                                  align-self="center"
                                >
                                  <b-img
                                    src="img/payg-logo.png"
                                    style="max-width: 40px"
                                    
                                    fluid
                                  ></b-img>
                                </b-col>
                                <b-col cols="10" class="pl-1 pr-0">
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-1"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b style="font-size: 14px">
                                        See new, flexible monthly plans!</b
                                      >
                                    </b-col>
                                  </b-row>
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-0"
                                  >
                                    <b-col
                                      cols="pl-0 pr-0"
                                      style="max-width: 380px"
                                    >
                                                                            Start for less. Then, pay as low as 99&#162;/mo/user. Cancel any time.



                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
              <b-row class="pt-2 pb-3 pl-3 reduced_pl_pr">
                <b-col
                  style="background-color: #e7f8fd; max-width: 496px"
                  class="pt-3 pb-3"
                >
                  <b-row>
                    <b-col
                      cols="2"
                      class="reduced_pl_pr pl-0 pr-1"
                      align-self="center"
                    >
                      <b-img
                        src="img/tb-ic-paypal@2x.png"
                        style="max-width: 40px"
                        fluid
                      ></b-img>
                    </b-col>
                    <b-col cols="10" class="pl-0 pr-0">
                      <b-row style="justify-content: left" class="pt-1">
                        <b-col cols="pl-0 pr-0">
                          <b style="font-size: 14px">
                            Buy Now, Pay Later with PayPal</b
                          >
                        </b-col>
                      </b-row>
                      <b-row style="justify-content: left" class="pt-0">
                        <b-col cols="pl-0 pr-0">
                          <b style="font-size: 14px; color: #c84141"
                            >4 interest-free payments of ${{ getPayin4() }} </b
                          >
                          <b class="hide-when-small">with Pay in 4</b>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="pt-2">
                <b-col md="12" class="reduced_pl_pr">
                  <b-button
                    pill
                    class="full-width blue-button"
                    v-if="stock > 0 && selectedQuantity <= stock"
                    v-on:click="onAddCart()"
                  >
                    <span style="font-size: 18px">Add to Cart</span>
                  </b-button>
                  <b-button
                    pill
                    disabled
                    style="
                      background-color: #12b8ed;
                      border: none;
                      padding: 10px 30px;
                    "
                    v-else
                  >
                    <span class="">Add to Cart</span>
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="pt-2 pb-3 pl-3 reduced_pl_pr">
                <b-col
                  style="
                    background-color: rgba(194, 194, 194, 0.1);
                    max-width: 496px;
                  "
                  class="pt-3 pb-3"
                >
                  <b-row>
                    <b-col
                      class="col-2 reduced_pl_pr pl-0 pr-0"
                      align-self="center"
                    >
                      <b-img
                        src="img/box1.png"
                        style="height: 48px; height: 48px"
                      ></b-img>
                    </b-col>
                    <b-col align-self="center">
                      <b-row style="justify-content: left" class="pt-2">
                        Free US shipping for $50 or above. Worldwide Shipping.
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row
            style="width: 100%; position: relative; padding-bottom: 10px"
            align-h="center"
            class="main-jumbotron reduced-pb-0 pt-5"
          >
            <b-col cols="12" class="pl-0 pr-0">
              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%" class="h1-font">
                  All New Truthbrush Classic Tracker
                </h1>
              </b-row>
              <b-row
                class="
                  justify-content-center
                  align-center
                  pt-2
                  pl-3
                  pr-3
                  h4-font
                "
                style="
                  max-width: 700px;
                  margin: auto !important;
                  font-size: 18px;
                "
              >
                The new Truthbrush Classic Tracker is our most advanced, oral
                care tracking technology at an affordable price! Built-in
                battery lasts up to 12 months. Works with any toothbrush; manual
                or electric; any brand. Pairs with app to set goals, get
                feedback, earn rewards and share with your dentist.
              </b-row>
              <b-row class="pt-5">
                <b-col class="pr-5 pl-5 reduced_pl_pr">
                  <b-img
                    src="/img/new_classic.jpg"
                    style="max-height: 650px"
                    center
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row
            style="width: 100%; position: relative; padding-bottom: 60px"
            align-h="center"
            class="main-jumbotron reduced-pb-0 pt-1"
          >
            <b-col cols="12" class="pl-0 pr-0">
              <b-row
                class="blue-text justify-content-center"
                style="color: #12b8ed"
              >
                Personalize your Truthbrush Classic
              </b-row>

              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 820px; color: black; text-align: center">
                  Give your Truthbrush Tracker
                </h1>
              </b-row>
              <b-row>
                <b-col>
                  <b-img src="img/newlook.png" center style="max-width: 240px">
                  </b-img>
                </b-col>
              </b-row>
              <b-row class="mt-3 mb-5" hidden>
                <b-col cols="12" style="text-align: center">
                  <router-link to="/select_t3">
                    <b-button
                      pill
                      variant="primary"
                      size="lg"
                      class="hub-blue btn-truthbrush select-btn"
                      >Select your skin</b-button
                    >
                  </router-link>
                </b-col>
                <b-col
                  cols="12"
                  class="pt-5 pl-0 pr-0"
                  style="text-align: center"
                >
                  <b-img-lazy fluid src="img/pro-group-min.jpg"></b-img-lazy>
                </b-col>
              </b-row>
              <SkinSelector class="pt-3 pb-5" ref="skinselctor"></SkinSelector>
            </b-col>
          </b-row>

          <b-row class="pt-0">
            <b-col class="pl-0 pr-0">
              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%" class="h1-font">
                  Packaging Content
                </h1>
              </b-row>
              <b-row
                class="
                  justify-content-center
                  align-center
                  pt-2
                  pl-3
                  pr-3
                  h4-font
                "
                style="
                  max-width: 700px;
                  margin: auto !important;
                  font-size: 18px;
                "
              >
                The Truthbrush consists of Tracker and Hub, both are required
                for the system to work. Each Hub can support multiple Trackers
                at the same time. Additional Hub can be added for expanded
                coverage area. If you have never purchased Truthbrush before,
                please select one of the bundles. If you already have a Hub and
                would like to purchase additional Tracker or Tracker Pro, please
                select the Tracker Pro only option. Image for illustration only,
                actual packaging and content varies based on actual order.
              </b-row>
              <b-row class="pt-5">
                <b-col class="pr-5 pl-5 reduced_pl_pr">
                  <b-img
                    src="/img/hero2-min.png"
                    style="max-height: 650px"
                    center
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="pt-5">
            <b-col class="pl-0 pr-0">
              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%" class="h1-font">
                  Technical Specification
                </h1>
              </b-row>
              <b-row
                class="
                  justify-content-center
                  align-center
                  pt-2
                  pl-3
                  pr-3
                  h4-font
                "
                style="
                  max-width: 700px;
                  margin: auto !important;
                  font-size: 18px;
                "
              >
                Truthbrush Classic Tracker+Hub
              </b-row>

              <b-row class="pt-5">
                <b-col cols="6" md="6" class="pb-5 reduced_pl_pr">
                  <b-row>
                    <b-col class="reduced_pl_pr">
                      <b-img
                        src="/img/diagram-tracker-en.png"
                        center
                        style="max-height: 360px; max-width: 100%"
                        class="image-side-2-side"
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row
                    style="
                      justify-content: center;
                      font-size: 22px;
                      padding-top: 20px;
                    "
                    class="h4-font"
                  >
                    Truthbrush Tracker
                  </b-row>
                </b-col>
                <b-col cols="6" md="6" class="reduced_pl_pr">
                  <b-row>
                    <b-col class="reduced_pl_pr">
                      <b-img
                        src="/img/travel_hub_illustration.jpg"
                        center
                        style="max-height: 360px; max-width: 100%"
                        class="image-side-2-side"
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row
                    style="
                      justify-content: center;
                      font-size: 22px;
                      padding-top: 20px;
                    "
                    class="h4-font"
                  >
                    Truthbrush Hub
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pt-0 pl-5 pr-5 reduced_pl_pr">
                <b-col cols="12">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="pt-3 spec">
                <b-col cols="6">
                  <b-row>
                    <b-col cols="12">
                      <b>Dimension/Weight</b>
                    </b-col>
                    <b-col cols="12"> 0.9*0.29 inch, 0.18 Ounce </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Attachment</b>
                    </b-col>
                    <b-col cols="12"> Elastic stripe (Fit all) </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Wireless communication</b>
                    </b-col>
                    <b-col cols="12"> Bluetooth LE </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Water resistance</b>
                    </b-col>
                    <b-col cols="12"> Splash </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Battery</b>
                    </b-col>
                    <b-col cols="12"> Built-in, up to 1 year usage </b-col>
                  </b-row>
                </b-col>

                <b-col cols="6">
                  <b-row>
                    <b-col cols="12">
                      <b>Voltage</b>
                    </b-col>
                    <b-col cols="12"> 5v DC 500mA </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Plug type</b>
                    </b-col>
                    <b-col cols="12"> Standard USB </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Working disntance</b>
                    </b-col>
                    <b-col cols="12"> 30 feet</b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Multiple tracker support</b>
                    </b-col>
                    <b-col cols="12"> Yes </b-col>
                  </b-row>
                  <b-row class="pt-3">
                    <b-col cols="12">
                      <b>Wireless protocol</b>
                    </b-col>
                    <b-col cols="12"> WiFi 2.4GHz </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="justify-content: center" class="pt-5">
                <a href="/#/product">Additional information</a>
              </b-row>
              <b-row class="pt-3 pl-5 pr-5 reduced_pl_pr">
                <b-col cols="12">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%; text-align: center" class="h1-font">
                  Frequently Asked Questions
                </h1>
              </b-row>
              <b-row class="pl-5 pr-5 reduced_pl_pr">
                <VueFaqAccordion
                  :items="myItems"
                  :activeColor="activeColorAccordian"
                  :borderColor="borderColorAccordian"
                />
              </b-row>
              <b-row style="justify-content: center" class="pt-5 pb-5">
                <a href="/#/faq">Visit our FAQ section</a>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>

      <b-row>
        <Checkout-Express id="my-modal" ref="my-modal"> </Checkout-Express>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import storage from "../storage";
import store from "../store";
import VueFaqAccordion from "vue-faq-accordion";
import DropdownMenu from "@innologica/vue-dropdown-menu";
import CheckoutExpress from "./../components/CheckoutExpress";
import env from "./../env";
import { getReviews } from "../api/store.js";
import ReviewPanel from "./../components/ReviewPanel";
import SkinSelector from "./../components/SkinSelector";

export default {
  name: "ProductSelect",
  components: {
    NavHeader,
    NavFooter,
    VueFaqAccordion,
    ReviewPanel,
    SkinSelector,
    DropdownMenu,
    CheckoutExpress,
  },
  data() {
    return {
      show: false,
      selectedindex: 0,
      hoverindex: 0,
      adaptor: 0,
      selectedhubindex: 0,
      selectedproduct: 0,
      selectedstyle1: 0,
      selectedstyle2: 1,
      selectedstyle3: 2,
      selectedstyle4: 3,
      selectedbattery: 1,

      selectedstyle1open: false,
      selectedstyle2open: false,
      selectedstyle3open: false,
      selectedstyle4open: false,
      selectedbatteryopen: false,

      t1rating: 0,
      t2rating: 0,
      t1count: 0,
      t2count: 0,

      stock: 9999,
      imagelist: [],
      activeColorAccordian: "#000000",
      borderColorAccordian: "#d9dadb",
      extrasensorclass: [false, false, false, false, false, false, false],
      myItems: [
        {
          title: "1. What is a Truthbrush tracker?",
          value:
            "The Truthbrush tracker is a small, decorative device that fits on any manual or electric toothbrush. The tracker records motion activity when the toothbrush is used. This activity is displayed in the Truthbrush mobile application. It displays daily activity like a fitness tracker and includes time of day, brush duration, mouth coverage, and movement analysis. The tracker also has a configurable beep timer to help build proper habits.",
        },
        {
          title: "2. What is the Truthbrush hub?",
          value:
            "The Truthbrush hub is a unit that plugs into any wall outlet. The hub connects to the local Wi-Fi and routes data from all Truthbrush trackers within a 30 ft. range to the Truthbrush service. The hub collects data passively in the background.",
        },

        {
          title:
            "3. Is there a monthly fee after purchasing the tracker and hub?",
          value: "No.",
        },
        {
          title: "4. Do I need more than one hub?",
          value:
            "The hub is designed to accommodate multiple Truthbrush trackers. The hub will collect data from all trackers within 30 ft. Multiple hubs can be used in large homes where the bathrooms might be spread out.",
        },
        {
          title: "5. Does my phone need to be in the bathroom when I brush?",
          value:
            "No, Truthbrush is specifically designed to avoid bringing a phone into the bathroom or the need to open an any app. Your phone can be turned off and it will not impact the ability for Truthbrush to collect data. Parents do not want their kids looking at the phone in the bathroom and the data can never be reliably collected when the phone is required.",
        },
        {
          title: "6. Is the Truthbrush tracker waterproof?",
          value:
            "The Truthbrush tracker is IPX4 water resistant and will work properly under normal brushing conditions. This includes the water and toothpaste that may contact the tracker during brushing and cleaning.",
        },
        {
          title: "7. Do I need to start the tracker when I brush?",
          value:
            "No, Truthbrush is designed so that you simply pick up the toothbrush and brush as you normally do, there are no stop or start buttons! The tracker will wake up on its own when you list the toothbrush and start recording. Truthbrush can tell the difference between toothbrushing activity and simply applying toothpaste or cleaning. The resulting data will reflect actual brush activity.",
        },
        {
          title: "8. Can multiple trackers work at the same time?",
          value:
            "Yes! Multi-tracker multi-user at the same time, with data collection handled by the hub seamlessly.",
        },
      ],
      optionbattery: [
        {
          value: 0,
          text: "Standard - 6 months",
          caption: "6 months - built-in battery",
        },
        {
          value: 1,
          text: "Extended - 1 year",
          caption: "1 year - built-in battery",
        },
      ],
      options: [
        {
          value: 0,
          text: "Blue",
          url: "/img/products/swatch-t1-blue.png",
        },
        {
          value: 1,
          text: "Yellow",
          url: "/img/products/swatch-t1-orange.png",
        },
      ],
      options_old: [
        {
          value: 0,
          text: "Flamingo",
          url: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/swatch-flamingo.png",
          url2: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/tracker-flamingo-min.png",
        },
        {
          value: 1,
          text: "Astronaut",
          url: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/swatch-astranout.png",
          url2: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/tracker-astronaut-min.png",
        },
        {
          value: 2,
          text: "Unicorn",
          url: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/swatch-unicorn.png",
          url2: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/tracker-unicorn-min.png",
        },
        {
          value: 3,
          text: "Orange",
          url: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/swatch-orange.png",
          url2: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/tracker-orange-min.png",
        },
        {
          value: 4,
          text: "Peacock",
          url: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/swatch-peacock.png",
          url2: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/tracker-peacock-min.png",
        },
        {
          value: 5,
          text: "Dinosaur",
          url: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/swatch-dinosour.png",
          url2: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/tracker-dinosaur-min.png",
        },
        {
          value: 6,
          text: "Heart",
          url: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/swatch-heart.png",
          url2: "https://candibell-shop-image.s3.amazonaws.com/products/tracker/tracker-heart-min.png",
        },
      ],
      productname: "",
      stripe: null,
      selectedQuantity: "1",
    };
  },
  methods: {
    gotoSubscription(){
        window.location.href = "/#/select_t6";
    },
    gotoreview(key) {
      window.location.href = "/#/review?product=" + key;
    },
    getBundlePrice(bundle, applycoupon, index) {
      var obj = [];
      if (index == 0) {
        let style = this.options[this.selectedstyle1].text.toLowerCase();
        let trackerproduct = store.state.inventory.t1a;
        if (this.selectedbattery == 1) {
          trackerproduct = store.state.inventory.t1b;
        }
        let hubproduct = store.state.inventory.standardhub;
        if (this.selectedhubindex == 0) {
          hubproduct = store.state.inventory.travelhub;
        }
        obj.push({ sku: trackerproduct[style], quantity: 1 });
        obj.push({ sku: hubproduct, quantity: 1 });

        if(this.adaptor==1){
          let adaptor_us = store.state.inventory.adaptor_us;
          obj.push({ sku: adaptor_us, quantity: 1 });
        }else if(this.adaptor==2){
          let adaptor_au = store.state.inventory.adaptor_au;
          obj.push({ sku: adaptor_au, quantity: 1 });
        }
      } else if (index == 1) {
        let style1 = this.options[this.selectedstyle1].text.toLowerCase();
        let style2 = this.options[this.selectedstyle2].text.toLowerCase();
        let trackerproduct = store.state.inventory.t1a;
        if (this.selectedbattery == 1) {
          trackerproduct = store.state.inventory.t1b;
        }
        let hubproduct = store.state.inventory.standardhub;
        if (this.selectedhubindex == 0) {
          hubproduct = store.state.inventory.travelhub;
        }
        obj.push({ sku: trackerproduct[style1], quantity: 1 });
        obj.push({ sku: trackerproduct[style2], quantity: 1 });
        obj.push({ sku: hubproduct, quantity: 1 });
      } else if (index == 2) {
        let style = this.options[this.selectedstyle1].text.toLowerCase();
        let trackerproduct = store.state.inventory.t1a;
        if (this.selectedbattery == 1) {
          trackerproduct = store.state.inventory.t1b;
        }
        obj.push({ sku: trackerproduct[style], quantity: 1 });
      }
      return storage.calculateBundleDiscount(bundle, applycoupon, obj);
    },
    getCoupon() {
      //console.log("get:" + store.state.couponid);
      return store.state.couponid;
    },
    getPayin4() {
      var amount = this.getBundlePrice(
        true,
        store.state.discount_percent > 0,
        this.selectedproduct
      );
      return (amount / 4.0).toFixed(2);
    },
    getproductInfo() {
      var prodname = "";

      if (this.selectedproduct == 0) {
        prodname = "1 Tracker Bundle";
        return (
          prodname +
          " $" +
          this.getBundlePrice(true, store.state.discount_percent > 0, 0)
        );
      } else if (this.selectedproduct == 1) {
        prodname = "2 Trackers Bundle";
        return (
          prodname +
          " $" +
          this.getBundlePrice(true, store.state.discount_percent > 0, 1)
        );
      } else if (this.selectedproduct == 2) {
        prodname = "Truthbrush Tracker";
        return (
          prodname +
          " $" +
          this.getBundlePrice(true, store.state.discount_percent > 0, 2)
        );
      }
    },
    getSelectStyleClass(index) {
      if (this.selectedstyle1 == index) {
        return "product-select-box2";
      }
      return "product-select-box";
    },
    getSelectHubClass(index) {
      if (this.adaptor == index) {
        return "product-select-box2";
      }
      return "product-select-box";
    },
    getSelectProductClass(index) {
      //console.log(index + " " + this.selectedproduct);
      if (this.selectedproduct == index) {
        return "product-select-box2";
      }
      return "product-select-box";
    },
    setUnderline(index, val) {
      this.extrasensorclass = [false, false, false, false, false, false, false];
      this.extrasensorclass[index] = val;
    },

    onAddCart() {
      var list = [];

      let sku_standard_hub = store.state.inventory.standardhub;
      sku_standard_hub.metadata = {};
      sku_standard_hub.metadata.image0 = sku_standard_hub.images[0];

      let sku_travel_hub = store.state.inventory.travelhub;
      sku_travel_hub.metadata = {};
      sku_travel_hub.metadata.image0 = sku_travel_hub.images[0];

      if (this.selectedproduct == 0) {
        let style = this.options[this.selectedstyle1].text.toLowerCase();
        let trackerproduct = store.state.inventory.t1a;
        if (this.selectedbattery == 1) {
          trackerproduct = store.state.inventory.t1b;
        }
        trackerproduct[style].metadata = {};
        trackerproduct[style].metadata.image0 = trackerproduct[style].images[0];
        list.push({ sku: trackerproduct[style], quantity: 1 });

        if (this.selectedhubindex == 1) {
          list.push({ sku: sku_standard_hub, quantity: 1 });
        } else {
          list.push({ sku: sku_travel_hub, quantity: 1 });
        }

        //add adaptors as needed
        if(this.adaptor==1){
          let adaptor_us = store.state.inventory.adaptor_us;
          adaptor_us.metadata = {};
          adaptor_us.metadata.image0 = adaptor_us.images[0];
          list.push({ sku: adaptor_us, quantity: 1 });
        }else if(this.adaptor==2){
          let adaptor_au = store.state.inventory.adaptor_au;
          adaptor_au.metadata = {};
          adaptor_au.metadata.image0 = adaptor_au.images[0];
          list.push({ sku: adaptor_au, quantity: 1 });
        }


      } else if (this.selectedproduct == 1) {
        let style1 = this.options[this.selectedstyle1].text.toLowerCase();
        let style2 = this.options[this.selectedstyle2].text.toLowerCase();
        let trackerproduct = store.state.inventory.t1a;
        if (this.selectedbattery == 1) {
          trackerproduct = store.state.inventory.t1b;
        }
        trackerproduct[style1].metadata = {};
        trackerproduct[style1].metadata.image0 =
          trackerproduct[style1].images[0];
        trackerproduct[style2].metadata = {};
        trackerproduct[style2].metadata.image0 =
          trackerproduct[style2].images[0];

        list.push({ sku: trackerproduct[style1], quantity: 1 });
        list.push({ sku: trackerproduct[style2], quantity: 1 });
        if (this.selectedhubindex == 1) {
          list.push({ sku: sku_standard_hub, quantity: 1 });
        } else {
          list.push({ sku: sku_travel_hub, quantity: 1 });
        }
      } else if (this.selectedproduct == 2) {
        let style = this.options[this.selectedstyle1].text.toLowerCase();
        let trackerproduct = store.state.inventory.t1a;
        if (this.selectedbattery == 1) {
          trackerproduct = store.state.inventory.t1b;
        }
        trackerproduct[style].metadata = {};
        trackerproduct[style].metadata.image0 = trackerproduct[style].images[0];
        list.push({ sku: trackerproduct[style], quantity: 1 });
      }

      storage.onAddCart(list, this);
    },

    getStockSKU() {
      this.stock = 9999;
    },
    clickbattery(index) {
      this.selectedbattery = index;
      this.selectedbatteryopen = false;
      this.clicksku(this.selectedproduct);
    },
    clickstyle(index) {
      //console.log("st1:" + index);
      this.selectedstyle1open = false;
      this.selectedstyle1 = index;
      this.clicksku(this.selectedproduct);
    },
    clickstyle2(index) {
      //console.log("st2:" + index);
      this.selectedstyle2open = false;
      this.selectedstyle2 = index;
      this.clicksku(this.selectedproduct);
    },

    clicksku_hub(index) {
      this.adaptor = index;
      this.populationImageView(this.selectedproduct);
    },
    clicksku(index) {
      this.selectedproduct = index;
      this.populationImageView(index);
      this.hoversample(0);
    },

    populationImageView(productindex) {
      //console.log('prodindex:'+productindex)
      this.imagelist = [];
      if (productindex == 0) {
        let style = this.options[this.selectedstyle1].text.toLowerCase();
        if (this.selectedbattery == 0) {
          this.imagelist.push(store.state.inventory.t1a[style].images[0]);
          this.imagelist.push(store.state.inventory.t1a[style].images[5]);
          this.imagelist.push(store.state.inventory.t1a[style].images[1]);
          if (this.selectedhubindex == 1) {
            this.imagelist.push(store.state.inventory.t1a[style].images[2]);
          } else {
            this.imagelist.push(store.state.inventory.t1a[style].images[3]);
          }
          this.imagelist.push(store.state.inventory.t1a[style].images[4]);
        } else {
          this.imagelist.push(store.state.inventory.t1b[style].images[0]);
          this.imagelist.push(store.state.inventory.t1b[style].images[5]);
          this.imagelist.push(store.state.inventory.t1b[style].images[1]);
          if (this.selectedhubindex == 1) {
            this.imagelist.push(store.state.inventory.t1b[style].images[2]);
          } else {
            this.imagelist.push(store.state.inventory.t1b[style].images[3]);
          }
          this.imagelist.push(store.state.inventory.t1b[style].images[4]);
        }
      } else if (productindex == 2) {
        let style1 = this.options[this.selectedstyle1].text.toLowerCase();
        //let style2 = this.options[this.selectedstyle2].text.toLowerCase();
        if (this.selectedbattery == 0) {
          this.imagelist.push(store.state.inventory.t1a[style1].images[0]);
          this.imagelist.push(store.state.inventory.t1a[style1].images[5]);
          this.imagelist.push(store.state.inventory.t1a[style1].images[1]);
          this.imagelist.push(store.state.inventory.t1a[style1].images[4]);
        } else {
          this.imagelist.push(store.state.inventory.t1b[style1].images[0]);
          this.imagelist.push(store.state.inventory.t1b[style1].images[5]);
          this.imagelist.push(store.state.inventory.t1b[style1].images[1]);

          this.imagelist.push(store.state.inventory.t1b[style1].images[4]);
        }
      }
      /*
      else if (productindex == 2) {
        let style = this.options[this.selectedstyle1].text.toLowerCase();
        if(this.selectedbattery==0){
          this.imagelist.push (store.state.inventory.t1a[style].images[0]);
          this.imagelist.push (store.state.inventory.t1a[style].images[2]);
          this.imagelist.push (store.state.inventory.t1a[style].images[3]);
          this.imagelist.push (store.state.inventory.t1a[style].images[4]);
          this.imagelist.push (store.state.inventory.t1a[style].images[5]);
        }else{
          this.imagelist.push (store.state.inventory.t1b[style].images[0]);
          this.imagelist.push (store.state.inventory.t1b[style].images[2]);
          this.imagelist.push (store.state.inventory.t1b[style].images[3]);
          this.imagelist.push (store.state.inventory.t1b[style].images[4]);
          this.imagelist.push (store.state.inventory.t1b[style].images[5]);
        }
      }
      */
    },

    hoversample(index) {
      this.selectedindex = index;
      this.hoverindex = index;
      this.selectedimage();
    },
    selectedimage() {
      if (this.selectedindex < this.imagelist.length) {
        return this.imagelist[this.selectedindex];
      }
    },

    shown() {},
  },
  mounted() {
    var context = this;
    //context.show = true;
    /*
    this.$loadScript(
      "https://www.paypal.com/sdk/js?client-id=AWUgRFc0nEW12AaTo-ebhlb0ufbIIhI3w-FL2G1FGo4hPTkfnYNufBtPUWZUUzhsDy6TWebKwmSiPWNf&components=buttons,funding-eligibility" // production
      //"https://www.paypal.com/sdk/js?client-id=AUx-KqcROyXWPOXnqCpF1VZpdJrwfP_yvcsJOcQMDHJNO2Pq6ANmIF-WLFXkjt_H-bv9PsLAJDDh0x3X&components=buttons,funding-eligibility"   // sandbox
    ).then(() => {});
*/

    getReviews()
      .then((res) => {
        context.t1count = res.data[0].totalcount;
        if (context.t1count > 0) {
          context.t1rating = res.data[0].totalstar / context.t1count;
        } else {
          context.t1rating = 0;
        }
        this.$refs.t1reviewpanel_a.update(
          context.t1rating,
          context.t1count,
          1,
          0,
          "t1"
        );
        this.$refs.t1reviewpanel_b.update(
          context.t1rating,
          context.t1count,
          1,
          0,
          "t1"
        );
      })
      .catch(function () {});

    this.$refs.skinselctor.updateParent(this);

    var stripekey = env.stripe_public_key;
    this.$loadScript(
      "https://js.stripe.com/v3/" // production
    ).then(() => {
      //console.log("stripe loaded");
      context.stripe = window.Stripe(stripekey, {
        apiVersion: "2020-08-27",
      });
    });

    this.$loadScript("https://www.paypalobjects.com/api/checkout.js").then(
      () => {}
    );

    //this.$refs.skinselctor.update();

    storage.clearstorestate();
    //storage.populateSku(this, 0);
    storage.processCoupon();
    storage.saveCart2Store(this);
    this.clicksku(0);
    this.clickstyle(0);
  },
};
</script>

<style lang="scss">
.abouthero {
  background-color: black;
}
.spec .col-12 {
  text-align: center;
}
@media (max-width: 768px) {
  .padding-top-when-small {
    padding-top: 15px;
  }
  .pl-pr-0-sm {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .product-select-box2,
  .product-select-box {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .reduced-ml-mr {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (max-width: 1199px) {
  .aboutmaintext {
    color: black;
    font-size: 20px;
    padding-left: 5%;
    padding-right: 5%;
  }
  .featuretitle {
    font-size: 20px !important;
    padding-bottom: 10px;
  }
  .featuredescription {
    color: #696871;
    font-size: 14px !important;
    padding-bottom: 25px;
  }
  .no-v-padding-small {
    padding-top: 0 !important;
  }
  .reduce-font-small {
    font-size: 24px !important;
  }
}
@media (max-width: 768px) {
  .reduced-pt-small {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .trackerfeature,
  .trackerfeature > .row > .col-sm-6 > .row > .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .reduced-padding-top {
    padding-top: 30px !important;
  }
  .trackerfeature > .row > .col-md-6 > .row > .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (min-width: 1200px) {
  .aboutmaintext {
    color: black;
    font-size: 24px;
    padding-left: 15%;
    padding-right: 15%;
  }
}
.productcell {
  border-radius: 20px;
  background-color: #f0f4f5;
  width: 100%;
  height: 100%;
}
.productcellwhole:hover {
  border: 2px solid #2ebfde !important;
  cursor: pointer;
  border-radius: 20px;
}
.productcellwhole {
  border: 2px solid white !important;
  cursor: pointer;
  border-radius: 20px;
}
.activesku {
  border: 3px solid #2ebfde !important;
  border-radius: 20px !important;
}
.inactivesku {
  border: 3px solid transparent;
  border-radius: 20px !important;
  padding: 5%;
}
.position-absolute {
  position: fixed !important;
}
.b-overlay .spinner-border {
  color: #2ebfde !important;
}
.featuretitle {
  color: #19191b;
  font-size: 24px;
  padding-bottom: 10px;
}
.featuredescription {
  color: #696871;
}
.breadcrumb-item a {
  color: #05c5ee;
}
.breadcrumb-item {
  font-size: 16px;
}
.breadcrumb {
  background-color: transparent !important;
}
.overlay-blur {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
  color: rgba(130, 130, 130, 0.5);
  font-size: 50px;
  text-align: center;
  line-height: 100px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);
}
.underline-blue {
  border: 2px solid;
  border-color: #05c5ee;
  padding: 0px 0px;
}
.b-overlay .spinner-border {
  color: #2ebfde !important;
}
@media (max-width: 1199px) {
  .cart-nav {
    padding: 0.5rem 15px !important;
  }
  .hide-when-small-1200 {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .cart-nav {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
  }
  .hide-when-big-1200 {
    display: none;
  }
}
@media only screen and (min-width: 1440px) {
  .cart-nav {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
  }
  .b-nav-dropdown ul {
    display: none !important;
  }
}
.breadcrumb {
  padding-left: 0.5rem;
}
a {
  color: #12b8ed;
}
.product-select-box {
      padding-left: 10px !important;
    padding-right: 10px !important;
  border-radius: 5px;
  border: 4px solid;
  border-color: #bdbdbd;
  background-color: white;
}
.product-select-box2 {
      padding-left: 10px !important;
    padding-right: 10px !important;
  border-radius: 5px;
  border: 4px solid;
  border-color: #12b8ed;
  background-color: white;
}
hr {
  border-top: 1px solid #bdbdbd;
}
.faq-wrapper {
  max-width: 100% !important;
}
.accordion {
  border: 0px solid !important;
}
.accordion__title-text {
  font-size: 24px !important;
  text-align: left !important;
}
@media (max-width: 768px) {
  #my-modal {
    padding-left: 0 !important;
  }

  .reduced_pl_pr {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .accordion__title {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .h1-font {
    font-size: 28px !important;
    font-weight: 600 !important;
  }
  .h2-font {
    font-size: 24px !important;
  }
  .h3-font {
    font-size: 19px !important;
    font-weight: 600 !important;
  }
  .h4-font {
    font-size: 16px !important;
    text-align: left !important;
    width: 100%;
  }
  .accordion__title-text {
    font-size: 16px !important;
    text-align: left !important;
  }
  .image-side-2-side {
    max-height: 200px !important;
    max-width: 50%;
  }
  .full-width {
    width: 100% !important;
  }
  .accordion__toggle-button {
    text-align: left !important;
  }
}
.blue-button,
.blue-button:hover {
  background-color: #12b8ed;
  border: none;
  padding: 12px 60px;
}

.full-width.blue-button {
  width: 100%;
  max-width: 500px;
  height: 60px;

  span {
    font-size: 18px;
  }
}

.underlinestyle {
  border-bottom: 2px solid #12b8ed;
}

.dropdown-menu.show {
  width: 100%;
  max-width: 500px;
}

.modal-backdrop {
  opacity: 0.85 !important;
}
</style>